import { handleActions } from 'redux-actions';
import u from 'updeep';
import * as actions from './eceActions';
 
const initialState = {
  isFetchingStaticContent: false,
  landingStaticText: {},
  isFetchingThemes: false,
  themes: {},
  isFetchingPosters: false,
  posters: {},
  isFetchingEceStories: false,
  stories: {},
  isFetchingEceVideos: false,
  videos: {},
  isFetchingEceFilters: false,
  filters: {},
  isFetchingEceResources: false,
  resources: {},
  isFetchingDownloadPosters: false
}

export default handleActions({
  [actions.fetchEceStaticContent]: (state, action) => u({
    isFetchingStaticContent: true
  }, state),

  [actions.receiveEceStaticContent]: (state, action) => u({
    isFetchingStaticContent: false,
    landingStaticText: action.payload.data
  }, state),

  [actions.fetchEceThemes]: (state, action) => u({
    isFetchingThemes: true
  }, state),

  [actions.receiveEceThemes]: (state, action) => u({
    isFetchingThemes: false,
    themes: action.payload.data
  }, state),

  [actions.fetchEcePosters]: (state, action) => u({
    isFetchingPosters: true,
  }, state),

  [actions.receiveEcePosters]: (state, action) => u({
    isFetchingPosters: false,
    posters: action.payload.data
  }, state),

  [actions.fetchEceStories]: (state, action) => u({
    isFetchingEceStories: true,
  }, state),

  [actions.receiveEceStories]: (state, action) => u({
    isFetchingEceStories: false,
    stories: action.payload.data
  }, state),

  [actions.fetchEceVideos]: (state, action) => u({
    isFetchingEceVideos: true,
  }, state),

  [actions.receiveEceVideos]: (state, action) => u({
    isFetchingEceVideos: false,
    videos: action.payload.data
  }, state),

  [actions.fetchEceResources]: (state, action) => u({
    isFetchingEceResources: true,
  }, state),

  [actions.receiveEceResources]: (state, action) => u({
    isFetchingEceResources: false,
    resources: action.payload.data
  }, state),

  [actions.fetchGetEceLevelsFilters]: (state, action) => u({
    isFetchingEceFilters: true
  }, state),

  [actions.recieveGetEceLevelsFilters]: (state, action) => u({
    isFetchingEceFilters: false,
    filters: action.payload.levels
  }, state),

  [actions.postDownload]: (state, action) => u({
    isFetchingDownloadPosters: true 
  }, state),

  [actions.recievePostDownload]: (state, action) => u({
    isFetchingDownloadPosters: false,
  }, state),

}, initialState);



// WEBPACK FOOTER //
// ./src/redux/eceReducer.js